import MiniChefV2Abi from '@/lib/abi/MiniChefV2.json';
import { networkId } from '@/composables/useNetwork';
import { multicall } from '@/lib/utils/balancer/contract';
import { rpcProviderService } from '@/services/rpc-provider/rpc-provider.service';
import { ClaimFlakeStatus } from './types';

import { configService } from '../config/config.service';

export class ClaimFlakeService {
  public async getClaimFlakeStatus(
    account: string,
    farmPids: string[]
  ): Promise<ClaimFlakeStatus[]> {
    const claimStatusCalls = farmPids.map(pid => [
      configService.network.addresses.farmPool,
      'pendingFlake',
      [pid, account]
    ]);

    try {
      const result = (await multicall<ClaimFlakeStatus>(
        String(networkId.value),
        rpcProviderService.jsonProvider,
        MiniChefV2Abi,
        [...claimStatusCalls],
        {},
        true
      )) as ClaimFlakeStatus[];
      return result.map(
        i =>
          ({
            wholePending: i.wholePending,
            incAmount: i.incAmount,
            teamRoyalty: i.teamRoyalty
          } as ClaimFlakeStatus)
      );
    } catch (e) {
      console.log('[Claim] Claim Status Error:', e);
    }

    return [];
  }
}

export const claimFlakeService = new ClaimFlakeService();
